import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import './Who.css';

const Who = () => {
  return (
    <section className="who">
      <div className="who__inner">
        <Reveal className="who__heading">
          <p className="who__eyebrow">Who We Are</p>
          <h2 className="who__title">
            Consulting Excellence, Backed
            <br />
            by Execution.
          </h2>
        </Reveal>

        <Reveal className="who__copy" delay={80}>
          <p>
            VBS Financial Securities is recognized for an unwavering commitment
            to excellence, innovation, and measurable client outcomes. Our work
            spans financial consulting, risk-focused advisory, and structured
            support for organizations operating in dynamic environments.
          </p>
          <p>
            We believe strong decisions are built on insight, discipline, and
            resilience — especially in markets defined by volatility,
            uncertainty, complexity, and ambiguity (VUCA). Our role is to bring
            structure, clarity, and strategic direction when it matters most.
          </p>
          <p>
            We partner with clients as a long-term advisor, not a transactional
            provider — aligning our work with the realities of governance, risk
            tolerance, and sustainable growth.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Who;
